// extracted by mini-css-extract-plugin
module.exports = {"container":"M_x","containerSpaced":"M_bZ","buttonSize":"M_b0","feedbackContainer":"M_b1","policy":"M_b2","underline":"M_b3"};